// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Treatments/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_Main_Treatments{
  vaxiom_sys_organizations(
    where: { level: { _eq: "location" } }
    order_by: { name: asc }
  ) {
    id
    _id
    level
    name
  }
}

`